// Runtime configuration - values are injected during deployment
// For local development, these come from environment variables

interface Config {
  apiUrl: string
  environment: string
  cognito: {
    userPoolId: string
    clientId: string
    domain: string
  }
}

// These values are replaced during build/deployment
const config: Config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  environment: import.meta.env.VITE_ENVIRONMENT || 'local',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  },
}

export function getConfig(): Config {
  return config
}

export function isDevEnvironment(): boolean {
  return config.environment === 'dev' || config.environment === 'local'
}

export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100)
}

export function formatDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
